import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, CheckCircle, Users, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ClientReadyDocumentation() {
  const documentationTypes = [{
    id: 1,
    title: "Professional Proposals",
    description: "Detailed, branded proposals tailored to your migration scope and business requirements.",
    icon: FileText
  }, {
    id: 2,
    title: "Migration Templates",
    description: "Comprehensive templates for data mapping, validation, and audit-ready reporting.",
    icon: CheckCircle
  }, {
    id: 3,
    title: "Onboarding Materials",
    description: "Step-by-step guides and training resources to ensure smooth team adoption.",
    icon: Users
  }, {
    id: 4,
    title: "Best Practice Guides",
    description: "Industry-standard documentation for compliance, security, and operational excellence.",
    icon: BookOpen
  }];
  return <section className="bg-background py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16 animate-fade-in-up">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4 tracking-tight">
            Client-Ready Documentation
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Professional, polished materials that streamline your migration journey from proposal to go-live—designed for clarity, compliance, and confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12 animate-fade-in-up-delay-100">
          {documentationTypes.map((doc, i) => {
          const IconComponent = doc.icon;
          return <Card key={doc.id} data-index={i} className="border border-border shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[200ms] ease-[cubic-bezier(0.22,1,0.36,1)]">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary-light-background flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-primary" strokeWidth={2} />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-xl font-semibold text-foreground mb-2">
                        {doc.title}
                      </CardTitle>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {doc.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="text-center animate-fade-in-up-delay-200">
          <Button asChild size="lg" className="bg-primary text-white hover:bg-primary-hover shadow-soft hover:shadow-medium hover:-translate-y-0.5 transition-all duration-[120ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
            <Link to="/ContactPage">
              Request Sample Documentation
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}